// extracted by mini-css-extract-plugin
export default {"cell":"_6JhJS1LpYQ","cell-centered":"AUbhwnN-uq","cellCentered":"AUbhwnN-uq","cell-left":"YhQwQ40KJM","cellLeft":"YhQwQ40KJM","cell-small":"_3IHPJIxa4R","cellSmall":"_3IHPJIxa4R","cell-right":"_34VqXMI9xP","cellRight":"_34VqXMI9xP","cell-head":"W3Zu8lb4S2","cellHead":"W3Zu8lb4S2","cell-data":"C5m4cLTcKP","cellData":"C5m4cLTcKP"};
    if(module.hot) {
      // 1653462695727
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  